export const CustomDialogMessage = (
  checkQuantity,
  checkMaxUnitPrice,
  checkMinUnitPrice,
  maxBigQuantity,
  maxUnitPrice,
  maxProductPrice,
  minUnitPrice,
  minProductPrice,
  setDialogMsg
) => {
  const quantityMsg = `<h2 style="color: red">Quantity Warning!</h2><br /><p style="font-size: 1.2rem">Please <strong>double-check the quantity</strong> fields for each product and ensure the values are correct.<br /><br />This warning appears when a larger quantity than normal is detected (<strong>${maxBigQuantity}</strong>). If you are sure that the values are correct, click the PROCEED button below. </p> <br/>`;
  const unitPriceMaxMsg = `<h2 style="color: red">Maximum Unit Price Warning!</h2><br /><p style="font-size: 1.2rem">Please <strong>double-check the unit price</strong> fields for each product and ensure the values are correct. If the product code doesn't match, it may be a different product or a non-promo product. <br /><br /> This warning appears if the unit price (<strong>₱${maxUnitPrice}</strong>) exceeds the <strong>maximum (₱${maxProductPrice})</strong> known product price. If you are sure that the values are correct, click the PROCEED button below.</p> <br/>`;
  const unitPriceMinMsg = `<h2 style="color: red">Minimum Unit Price Warning!</h2><br /><p style="font-size: 1.2rem">Please <strong>double-check the unit price</strong> fields for each product and ensure the values are correct. If the product code doesn't match, it may be a different product or a non-promo product. 
      <br /><br /> This warning appears if the unit price (<strong>₱${minUnitPrice}</strong>) is below the <strong>minimum (₱${minProductPrice})</strong> known product price. If you are sure that the values are correct, click the PROCEED button below.</p> <br/>`;

  let message = "";

  if (checkQuantity) {
    message += quantityMsg;
  }

  if (checkMaxUnitPrice) {
    message += unitPriceMaxMsg;
  }

  if (checkMinUnitPrice) {
    message += unitPriceMinMsg;
  }

  setDialogMsg(message);
};
